<template>
  <div>
    <v-row align="center">
      <!-- Limit # of items in shopping cart switch -->
      <v-col cols="11">
        <div class="md-body-no-spacing feature-label feature-content">
          Limit # of Items in Shopping Cart
        </div>
      </v-col>
      <v-col cols="1">
        <v-tooltip location="top">
          <template v-slot:activator="{ props }">
          <v-switch
            style="width: 280px"
            v-bind="props"
            v-model="campaignItemsCountLimitEnabled"
            @update:modelValue="onItemsCountLimitToggle"
            data-testid="ct-experience-limit-item"
            :disabled="campaign.complete"
          >
          </v-switch>
          </template>
          <span
            >Allow shoppers to purchase a set number of items for their
            uniform or merchandise purchase</span
          >
        </v-tooltip>
      </v-col>
      <!-- divider -->
      <v-col
        class="feature-divider-flex"
        cols="12"
        v-if="campaignItemsCountLimitEnabled"
      >
        <v-divider />
      </v-col>
      <!-- Limit # of items per person - text field -->
      <v-col
        cols="12"
        v-if="campaignItemsCountLimitEnabled"
        class="feature-drawer pa-4"
      >
        <v-row>
          <v-col cols="5">
            <v-text-field
              label="Enter number of items allowed per person"
              prefix="#"
              type="number"
              :rules="[validateInteger, validateNotEmpty]"
              v-model="campaignItemsCountLimit"
              data-testid="ct-experience-limit-item-person"
              @update:modelValue="changeNumberOfItem"
              :disabled="campaign.complete"
            />
          </v-col>
        </v-row>
      </v-col>
      <!-- divider -->
      <v-col class="feature-divider-flex" cols="12">
        <v-divider />
      </v-col>
      <!-- Limit shopping cart $ amount switch -->
      <v-col cols="11">
        <div class="md-body-no-spacing feature-label feature-content">
          Limit Shopping Cart $ Amount
        </div>
      </v-col>
      <v-col cols="1">
        <v-tooltip location="top">
          <template v-slot:activator="{ props }">
          <v-switch
            style="width: 280px"
            v-bind="props"
            v-model="campaignPriceLimitEnabled"
            @update:modelValue="onPriceLimitToggle"
            data-testid="ct-experience-limit-total"
            :disabled="
              !storefrontPricingEnabled ||
                campaign.complete ||
                allowanceActive
            "
          >
          </v-switch>
          </template>
          <span v-if="!storefrontPricingEnabled">
            Activate storefront pricing to enable this feature
          </span>
          <span v-else-if="allowanceActive"
            >This feature is disabled if your store contains a shopper
            allowance</span
          ><span v-else
            >Allow shoppers to spend a specific amount of money on their
            purchases</span
          >
        </v-tooltip>
      </v-col>
      <!-- divider -->
      <v-col
        class="feature-divider-flex"
        cols="12"
        v-if="campaignPriceLimitEnabled && !allowanceActive"
      >
        <v-divider />
      </v-col>
      <!-- Limit shopping cart $ amount - text field -->
      <v-col
        cols="12"
        v-if="campaignPriceLimitEnabled && !allowanceActive"
        class="feature-drawer pa-4"
      >
        <v-row>
          <v-col cols="5">
            <v-text-field
              label="Enter dollar amount allowed per person"
              prefix="$"
              type="number"
              :rules="[validateNumber, validateNotEmpty]"
              v-model="campaignPriceLimit"
              data-testid="ct-experience-limit-total-amount"
              @update:modelValue="changePriceLimit"
              :disabled="campaign.complete"
            />
          </v-col>
        </v-row>
      </v-col>
      <!-- divider -->
      <v-col class="feature-divider-flex" cols="12">
        <v-divider />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import rules from "@/mixins/rules";
import helpers from "@/mixins/helpers";

export default {
  name: "StoreOrderLimits",

  mixins: [rules, helpers],

  props: {
    campaign: Object,
    editMode: Boolean,
    disableFields: Boolean,
    storefrontPricingEnabled: Boolean,
    // PR E: v2 allowance state (StoreAllowancePolicy enabled)
    // replaces the legacy numeric ``companyAllowance`` prop (from the
    // dropped ``company_allowance`` column). True => a per-shopper
    // allowance is configured, which disables the cart $-limit.
    allowanceActive: Boolean,
  },

  emits: [
    "campaign-changed",
    "update:price-limit-enabled",
    "update:items-count-limit-enabled",
  ],

  data() {
    return {
      campaignItemsCountLimitEnabled: false,
      campaignItemsCountLimit: 0,
      campaignPriceLimitEnabled: false,
      campaignPriceLimit: 0,
    };
  },

  methods: {
    changeNumberOfItem(val) {
      if (val) {
        this.campaignItemsCountLimit = parseInt(val);
      }
      this.$emit("campaign-changed");
    },

    changePriceLimit(val) {
      if (val) {
        this.campaignPriceLimit = parseInt(val);
      }
      this.$emit("campaign-changed");
    },

    onItemsCountLimitToggle(val) {
      this.$emit("update:items-count-limit-enabled", val);
      this.$emit("campaign-changed");
    },

    onPriceLimitToggle(val) {
      this.$emit("update:price-limit-enabled", val);
      this.$emit("campaign-changed");
    },

    /**
     * Returns the order limits data for saving.
     * Returns null for each limit that is disabled.
     */
    getData() {
      return {
        items_count_limit: this.campaignItemsCountLimitEnabled
          ? this.campaignItemsCountLimit
          : null,
        price_limit: this.campaignPriceLimitEnabled
          ? this.campaignPriceLimit
          : null,
      };
    },

    /**
     * Loads order limit data from a campaign object.
     */
    loadFromCampaign(campaign) {
      this.campaignItemsCountLimitEnabled = !!campaign.items_count_limit;
      this.campaignItemsCountLimit = campaign.items_count_limit;
      this.campaignPriceLimitEnabled = !!campaign.price_limit;
      this.campaignPriceLimit = campaign.price_limit;
    },
  },
};
</script>
